import React from "react";
import Loader from "../../components/common/Loader";
import diamondDummy from "../../assets/diamonds/diamond_round.png";
import { useSelector } from "react-redux";
import { Link } from "react-router-dom";
import Image from "../../components/Image";

const DiamondGridView = ({ dimonListLoading, dimondListData }) => {
  const authData = useSelector((state) => state?.auth);
  const handleError = (e) => {
    e.target.src = diamondDummy;
  };

  return (
    <div className="h-100 dimond-grid-view">
      {dimondListData?.inventory?.map((item) => {
        return (
          <Link
            className="item-link"
            to={authData?.token ? `/certified-dimond/${item?.id}` : `#`}
          >
            <div className="dimond-list-item">
              <div className="dimond-img">
                {/* <img
                  onError={handleError}
                  loading="lazy"
                  src={item?.image_url || diamondDummy}
                /> */}
                <Image url={item?.image_url || diamondDummy} />
              </div>
              <div
                className="dimond-title mt-3"
                title={`${item?.carat} Carat ${item?.shape} Diamond`}
              >
                {item?.carat} Carat {item?.shape} Diamond
              </div>
              <div className="dimond-sub-title">
                {item?.cut} . {item?.polish} . {item.symmetry}
              </div>
              {!authData?.userData && (
                <Link to="/login">
                  <button className="price-button">Login to view price</button>
                </Link>
              )}
              {authData?.userData && (
                <div className="dimond-title mb-3">$ {item?.total_price}</div>
              )}
            </div>
          </Link>
        );
      })}
    </div>
  );
};

export default DiamondGridView;
